import { Add } from '@project-lary/react-material-symbols';
import IconButton, { type IconButtonProps } from 'gcs-common/design-system/ui/icon-button';

interface PlusButtonProps {
  onClick: VoidFunction;
  iconSize: IconButtonProps['iconSize'];
}

const PlusButton = (props: PlusButtonProps) => {
  const { onClick, iconSize } = props;
  return (
    <IconButton
      Icon={Add}
      iconSize={iconSize}
      className="cursor-pointer rounded-full bg-new-button-background text-white"
      variant="ghost_neutral"
      onClick={onClick}
    />
  );
};

export default PlusButton;
